module.exports = __webpack_public_path__ + "assets/video/ingela.c0b469a.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ingela.ogv
// module id = 1072
// module chunks = 0